import React, { useState } from 'react';
import styled from '@emotion/styled';

import { Button } from '../../../../main/scripts/lumen';

export const DataUseAgreement = ({ message, onAcknowledge, onDecline }) => {
  const [loading, setLoading] = useState(false);
  return (
    <>
      <Heading>General data security acknowledgement</Heading>
      <Message>{message}</Message>
      <Actions>
        <Button
          type="button"
          variant="primary"
          size="md"
          disabled={loading}
          aria-busy={loading}
          style={{ width: '100%' }}
          onClick={() => {
            setLoading(true);
            onAcknowledge();
          }}
        >
          I have read and accept these terms
        </Button>
        <Button
          type="button"
          variant="default"
          size="md"
          style={{ width: '100%' }}
          onClick={onDecline}
        >
          Decline
        </Button>
      </Actions>
    </>
  );
};

const Heading = styled.h1`
  margin: 0;
  font-family: ${({ theme }) => theme.font.sans};
  font-size: ${({ theme }) => theme.fontSize.xl};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  line-height: 28px;
  color: ${({ theme }) => theme.color.fg.default};
  text-align: center;
`;

const Message = styled.span`
  font-size: ${({ theme }) => theme.fontSize.base};
  color: ${({ theme }) => theme.color.fg.default};
  line-height: ${({ theme }) => theme.lineHeight.base};
  white-space: pre-wrap;
`;

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;
